import React, { forwardRef } from 'react';
import styles from './FieldsGrid.styles';
import { COLUMN_SIZE, DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH } from 'components/common/DataGridDevEx/DataGrid.constants';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import DataGrid, { Column, Scrolling, GroupPanel, SearchPanel, LoadPanel, Selection, Sorting, HeaderFilter } from 'devextreme-react/data-grid';
import { withStyles } from '@material-ui/core';
import { IFieldsGridProps, IFieldsGridsHandle } from './FilterGrid.properties';
import { useFetchDashboardTypeQuickLinks } from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import CheckBox from 'devextreme/ui/check_box';

const FieldsGrid = (props: IFieldsGridProps, ref: React.Ref<IFieldsGridsHandle>) => {
    const { classes, selectedDashboardType, selectedDashboardId } = props;
    const [dashboardTypeQuickLinks, setDashboardTypeQuickLinks] = React.useState<any[]>([]);

    const fieldsGridRef = React.useRef<DataGrid>();
    const dashboardTypeQuickLinksMutation  = useFetchDashboardTypeQuickLinks();

    React.useEffect(() => { fetchDashboardTypeQuickLinks(); }, [selectedDashboardId, selectedDashboardType]);

    const fetchDashboardTypeQuickLinks = async () => {
        const data = await dashboardTypeQuickLinksMutation.mutateAsync({
            urlQueryParams: {
                DashboardType: selectedDashboardType
            }
        });

        setDashboardTypeQuickLinks(data?.QuickLinks ?? []);
    };

    React.useImperativeHandle(ref, () => ({
        deselectAll: () => {
            fieldsGridRef.current.instance.deselectAll();
        },
        getSelectedRowsData: () => {
            return fieldsGridRef.current.instance.getSelectedRowsData();
        },
    }));

    const handleRowClick = React.useCallback(
        (e) => {
            const keys = e.component.getSelectedRowKeys();
            const index = keys.indexOf(e.key);

            if (index > -1) {
                keys.splice(index, 1);
            } else {
                keys.push(e.key);
            }

            e.component.selectRows(keys, false);
        },
        []
    );

    const onCellPrepared = React.useCallback(
        (e) => {
            if (e.rowType === 'data' && e.columnIndex === 0) {
                //disable checkboxes that are not allowed to edit
                const element = e.cellElement.querySelector('.dx-select-checkbox');
                const checkBox = CheckBox.getInstance(element);
                checkBox?.option('disabled', (false));
            }
        },
        []
    );

    return (
        <DataGrid
            className={classes.FieldsGrid}
            dataSource={dashboardTypeQuickLinks}
            ref={fieldsGridRef}
            showBorders={true}
            renderAsync={true}
            remoteOperations={true}
            allowColumnResizing={true}
            columnResizingMode={'nextColumn'}
            hoverStateEnabled={true}
            showColumnHeaders={false}
            noDataText=''
            showColumnLines={false}
            onCellPrepared={onCellPrepared}
            onRowClick={handleRowClick}
        >
            <Selection mode='multiple' showCheckBoxesMode='always' />
            <Column
                type={'selection'}
                width={COLUMN_SIZE.sm0}
                minWidth={COLUMN_SIZE.sm0}

            />
            <HeaderFilter visible />
            <Column
                dataField={'Label'}
                allowHeaderFiltering={false}
                allowEditing={false}
            >
            </Column>
            <Sorting mode='none' />
            <GroupPanel visible={false} />
            <SearchPanel visible={true} />
            <Scrolling mode={'infinite'} />
            <LoadPanel shading={false} height={DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH} width={DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH} text={''} showPane={false} />
        </DataGrid >
    );
};

export default withStyles(styles, { index: 1 })(forwardRef(FieldsGrid));
